import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';
import CircularProgress from 'material-ui/CircularProgress';

import Message from '../Message';
import SendMessage from '../SendMessage';

class MessageList extends React.Component {
  constructor( props ) {
    super( props );
  }

  isSameDay = ( currentMessage = {}, diffMessage = {} ) => {
    if( !diffMessage.createdAt ) return false;

    const currentCreatedAt = moment.utc( Number( `${currentMessage.createdAt}000` ) );
    const diffCreatedAt = moment.utc( Number( `${diffMessage.createdAt}000` ) );

    if( !currentCreatedAt.isValid() || !diffCreatedAt.isValid() ) return false;

    return currentCreatedAt.isSame( diffCreatedAt, 'day' );
  };

  render() {
    const { data = [], messagesToSend, isOpened, hasMore, selectedChannelId, onFetchData, responses } = this.props;

    return (
      <div className="card chat-messages my-2 my-md-0">
        <div className="card-body py-2 pl-3 pr-0" id="messagesContainer" key={selectedChannelId}>
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            loadMore={onFetchData}
            hasMore={hasMore}
            loader={<div key="loading" className="text-center py-2">
              <CircularProgress size={20} thickness={3}/>
            </div>}
            useWindow={false}
            isReverse
          >
            {_.map( data, ( item, index ) => {
              const toShow = _.get( messagesToSend, item.id ) || item;
              const previous = messagesToSend ? messagesToSend[_.get( data, `${[index - 1]}.id` )] || data[index - 1] : data[index - 1];
              return (
                <div key={toShow.id || toShow.ref}>
                  {!this.isSameDay( toShow, previous )
                  && (
                    <div className="row no-gutters chat-messages-message-date">
                      <div className="col">
                        <span>{moment.utc( Number( `${toShow.createdAt}000` ) ).local().format( 'MMM DD, YYYY' )}</span>
                      </div>
                    </div>
                  )}
                  <Message
                    message={toShow}
                    previousMessage={previous}
                    isSameDay={() => this.isSameDay( toShow, previous )}
                  />
                </div>
              );
            } )}
          </InfiniteScroll>
        </div>

        <SendMessage isOpened={isOpened}
                     responses={responses}
                     disabled={!selectedChannelId}
                     channelId={selectedChannelId}
        />
      </div>
    )
  }
}

export default MessageList;



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChatDetail/MessageList/index.js